import zh from './zh-CN';
import en from './en-US';
const i18n = {
  'zh-CN': zh,
  'en-US': en
};
export default i18n;